import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/landing/Nav";
import { Hero, ProductStage } from "@/components/landing/Hero";
import { Pain } from "@/components/landing/Pain";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { LiveDemo } from "@/components/landing/LiveDemo";
import { Features } from "@/components/landing/Features";
import { Marquee } from "@/components/landing/Marquee";
import { Audience } from "@/components/landing/Audience";
import { Stats } from "@/components/landing/Stats";
import { Pricing } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA, Footer } from "@/components/landing/FinalCTA";

export default function Landing() {
  useLenis();
  return (
    <main data-testid="landing-page" className="relative">
      <div className="grain" />
      <Nav />
      <Hero />
      <ProductStage />
      <Pain />
      <HowItWorks />
      <LiveDemo />
      <Marquee />
      <Features />
      <Audience />
      <Stats />
      <Pricing />
      <FAQ />
      <FinalCTA />
      <Footer />
    </main>
  );
}
